<template>
	<div class="page auth">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><path d="M5.5,5.5A5.5,5.5,0,1,1,11,11,5.5,5.5,0,0,1,5.5,5.5ZM0,22V19.25c0-3,5-5.5,11-5.5s11,2.48,11,5.5V22Z"/></svg>
					<span class="navigation-title">{{$t('customers-area')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main no-padding-top">
				<div id="tabs" data-tabs="2">
					<div class="tabs-inner">
						<router-link
							v-for="tb in tabs"
							:key="tb.name"
							:class="['tab', {active: currentTab == tb}, {enabled: tb.enabled}]"
							:to="{name: tb.target}"
						>
							<span class="title">{{tb.description}}</span>
						</router-link>
					</div>
				</div>
				<transition name="slide-up" mode="out-in" appear>
					<router-view :key="$route.params.id"/>
				</transition>
			</section>
		</transition>
	</div>
</template>

<script>

export default {
	data() {
		let tabs = [
			{
				name: 'tab-1',
				description: this.$t('registered-user'),
				target: 'login',
				enabled: true
			},
			{
				name: 'tab-2',
				description: this.$t('register'),
				target: 'registration',
				enabled: true
			}
		];
		return {
			tabs: tabs
		}
	},
	computed: {
		currentTab() {
			let self = this;
			return this.tabs.find(e => e.target === self.$route.name);
		}
	},
}
</script>

<style>
.auth #tabs .tab .title {
	text-transform: uppercase;
}
</style>